<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="LAPORAN PENDAFTARAN TERNAKAN HARIAN AIMS">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3" >
            <w-form v-model="valid" @validate="cari" ref="frm">
            <div style="font-size:20px;font-weight:bold; text-align:center">
                LAPORAN PENDAFTARAN TERNAKAN HARIAN AIMS
            </div>
            <div style="font-size:20px; text-align:center">
                JABATAN PERKHIDMATAN VETERINAR MALAYSIA
            </div>
            <div style="font-size:20px; text-align:center;">
                <span style="vertical-align:middle; font-size:20px;">
                    TARIKH JANA LAPORAN:
                </span>
                <w-input
                    type="date"
                    v-model="pencarian.tarikh"
                    style="width:150px; display:inline-block; vertical-align:middle; margin-left:8px;"
                />
            </div>

            </w-form>
            <br>


          <div class="w-table-wrap" style="max-height: 900px;">
            <div class="table-profil-scrol">

                <br><br>
                <div style="font-size:18px; font-weight:bold">
                   ii. PENDAFTARAN TERNAKAN
                </div>
                <br>
              <table class="w-table" color="light" style="border:1px" width="100%">
                <thead>
                  <tr>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                        BIL
                     </th>
                      <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" >
                        NEGERI
                     </th>
                      <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" >
                        JENIS TERNAKAN
                     </th>
                      <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" >
                        JURUSAN TERNAKAN
                     </th>
                      <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        BAKA
                     </th>
                      <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        BILANGAN
                     </th>
                    
                  </tr>
                </thead>
                <tbody>
                    <template v-if="ternakan_negeri.length == 0">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="6"> Tiada Data.</td>
                        </tr>
                    </template>
                    <!-- <template  v-for="(dt, ind) in ternakan_negeri" :key="dt.id">
                   
                    <tr class="w-table__row" style="border: 1px solid #000;">
                        <td class="w-table__cell text-left" style="border: 1px solid #000;" rowspan="">{{ind+1}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.negeri ?? 0 }}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                            
                        </td>
                    </tr>
                  </template> -->
                  <template v-for="(negeri, i) in ternakan_negeri" :key="negeri.id">
            <!-- JIKA ADA TERNAKAN  -->
                        <template v-if="negeri.ternakan && negeri.ternakan.length">
                            <template v-for="(dt, j) in negeri.ternakan" :key="j">
                                <tr class="w-table__row" style="border:1px solid #000;">
                                    <!-- NO -->
                                    <td v-if="j === 0" :rowspan="negeri.ternakan.length" class="w-table__cell text-left" style="border:1px solid #000;"> 
                                        {{ i + 1 }}
                                    </td>
                                <!-- NEGERI -->
                                    <td v-if="j === 0" :rowspan="negeri.ternakan.length" class="w-table__cell text-left" style="border:1px solid #000;" >
                                        {{ negeri.negeri }}
                                    </td>
                                <!-- DATA -->
                                    <td class="w-table__cell" style="border:1px solid #000;">
                                        {{ dt.ternakan_nama }}
                                    </td>
                                    <td class="w-table__cell" style="border:1px solid #000;">
                                        {{ dt.jurusan_nama }}
                                    </td>
                                    <td class="w-table__cell" style="border:1px solid #000;">
                                        {{ dt.baka_nama }}
                                    </td>
                                    <td class="w-table__cell text-center" style="border:1px solid #000;">
                                        {{ dt.jumlah }}
                                    </td>
                                </tr>
                            </template>
                        </template>
            <!-- JIKA TIADA TERNAKAN -->
                        <template v-else>
                            <tr class="w-table__row" style="border:1px solid #000;">
                                <td class="w-table__cell text-left" style="border:1px solid #000;">
                                    {{ i + 1 }}
                                </td>
                                <td class="w-table__cell text-left" style="border:1px solid #000;">
                                    {{ negeri.negeri }}
                                </td>
                                <td class="w-table__cell" style="border:1px solid #000;" > - </td>
                                <td class="w-table__cell" style="border:1px solid #000;" > - </td>
                                <td class="w-table__cell " style="border:1px solid #000;" > - </td>
                                <td class="w-table__cell text-center" style="border:1px solid #000;" >0</td>
                            </tr>
                        </template>
                    </template>
                    <tr>
                        <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="5">JUMLAH KESELURUHAN</td>
                        <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan}}</td>
                    </tr>


                </tbody>
              </table>
              <br><br>

            </div>
          </div>
        </div>
        
        

        <br>
        <br>

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { GChart } from "vue-google-charts";

export default {
  extends: ZResource,
  props: {
    ternakan_negeri: [Array, Object],
    tarikhNow: [Array, Object],
    jumlah_keseluruhan: [Array, Object]
  },
  


   components: {
        GChart
    },
  data() {
    return {
      resourceurl: 'laporan_pengguna.pendaftaran_ternakan'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan Pengguna', route: '/laporan_pengguna' },
        { label: 'Pendaftaran Ternakan', route: 'laporan_pengguna/pendaftaran_ternakan' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
      pencarian: {
         tarikh: this.tarikhNow ?? '',
      },
     
      
    }
  },
  methods: {
    

   // createExcel() {
   //    const params = {
   //       lkp_negeri_id: this.pencarian.lkp_negeri_id || '',
   //       lkp_bandar_id: this.pencarian.lkp_bandar_id || '',
   //       lkp_daerah_id: this.pencarian.lkp_daerah_id || '',
   //       premis_id: this.pencarian.premis_id || '',
   //       lkp_status_id: this.pencarian.lkp_status_id || '',
   //       tarikh_lahir: this.pencarian.tarikh_lahir || '',
   //       // per_page: this.perPage || 10,
   //       excel: 1 // penanda untuk generate Excel
   //    };
   //    const queryString = new URLSearchParams(params).toString();
   //    const url = route('laporan.kelahiran') + '?' + queryString;
   //    window.open(url, '_blank');

   //  // const url = route('laporan.service.service_ai') + '?' + new URLSearchParams(params).toString();
   //  // window.open(url, '_blank');
   // },


    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       // params.page = 1;
       // params.per_page = this.perPage;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    


  },

  computed: {
    tarikhJana() {
        const now = new Date()

        return now
        .toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        })
        .replace(',', '')
    }
   },

   watch: {
    'pencarian.tarikh'(val) {
         clearTimeout(this._roleTimer)

         if (!val) {
            this.resetPencarian('pencarian')
            return
         }

         this._roleTimer = setTimeout(() => {
            this.$refs.frm.validate()
         }, 300)
      }
    
   },

  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.per-page-label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.per-page-select {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.per-page-select:hover {
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.4);
}

.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}

/* Header baris kedua */
.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 32px; /* sesuaikan dengan tinggi row pertama */
  background: #fff;
  z-index: 2;
}
</style>
